import { observer } from 'mobx-react-lite'
import type { CSSProperties, FC } from 'react'
import { useCallback, useMemo } from 'react'
import type { Placement } from '@floating-ui/react'
import type { CreateDataGrantModalStore } from './modal-store'
import { CreateDataGrantModalStep } from './modal-store'
import { useOrganizations } from '../../../../../stores/organization-store'
import type { APIOrganization } from '@visorpro/client'
import { SelectableListModal } from '../../../../../components/modals'
import type { Stores } from '../../../../../util/store'

export interface CreateDataGrantConsumerModalProps {
    anchor: HTMLElement
    placement?: Placement
    onClose(): void
    style?: CSSProperties
    containerStyle?: CSSProperties
    store: CreateDataGrantModalStore
    stores: Stores
}

export const CreateDataGrantConsumerModal: FC<CreateDataGrantConsumerModalProps> =
    observer(
        ({
            anchor,
            placement,
            onClose,
            style,
            containerStyle,
            store,
            stores,
        }) => {
            const organizations = useOrganizations(stores.organizations)

            const goToIndex = useCallback(() => {
                store.setStep(CreateDataGrantModalStep.Index)
            }, [])

            const onSelect = useCallback(
                (org: APIOrganization) => {
                    store.setConsumerOrganizationId(org.id)
                    store.setStep(CreateDataGrantModalStep.Index)
                },
                [stores],
            )

            const selectedIds = useMemo(() => {
                if (store.consumerOrganizationId) {
                    return new Set([store.consumerOrganizationId])
                }
            }, [store.consumerOrganizationId])

            return (
                <SelectableListModal
                    selectableListProps={{
                        onSelect,
                        isLoading: stores.organizations.isFetching,
                        items: organizations,
                        placeholder: 'Search consumer organization...',
                        selectedIds,
                    }}
                    placement={placement}
                    anchor={anchor}
                    onClose={onClose}
                    onBack={goToIndex}
                    containerStyle={containerStyle}
                    style={style}
                />
            )
        },
    )
